import { appstore, googleplay } from '@/utils/imagepath';
import React from 'react';
import { useSelector } from 'react-redux';

const MobileAppSection = ({ themeData }: any) => {
  const settingsData: any = useSelector<any>((state) => state?.settings);

  const appStorel =
    settingsData &&
    Object.keys(settingsData).length > 0 &&
    settingsData?.WebmasterSettings?.app_store_link;

  const playStore =
    settingsData &&
    Object.keys(settingsData).length > 0 &&
    settingsData?.WebmasterSettings?.play_store_link;

  return (
    <>
      {' '}
      <section className="mobapp-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-4">
              <div className="mobapp-content">
                <div className="section-title text-start">
                  <h2
                    style={{
                      color: `#${themeData?.theme_3?.home?.section_13?.h2color}`,
                    }}
                  >
                    {themeData?.theme_3?.home?.section_13?.title}
                  </h2>
                  <p
                    style={{
                      color: `#${themeData?.theme_3?.home?.section_13?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_3?.home?.section_13?.paragraph}
                  </p>
                </div>
                <ul className="app-highlights">
                  {themeData?.theme_3?.home?.section_13?.check_list.map(
                    (items: any) => {
                      return (
                        <li>
                          <div className="d-flex align-items-center">
                            <span className="flex-shrink-0 icon-box">
                              <img src={items.icons} alt="" />
                            </span>
                            <div className="flex-grow-1">
                              <h5
                                style={{
                                  color: `#${themeData?.theme_3?.home?.section_13?.h3color}`,
                                }}
                              >
                                {items.title}
                              </h5>
                            </div>
                          </div>
                        </li>
                      );
                    }
                  )}
                </ul>
                {/* <div className='qr-grid'>
                                    <div className='d-flex'>
                                        <span className="flex-shrink-0">
                                            <img src={qrcode} alt="" />
                                        </span>
                                        <div className="flex-grow-1 ms-2">
                                            <h6>Scan here</h6>
                                            <div className='profile-rating'>
                                                <span className='secondary-text'>
                                                    <i className='fas fa-star'></i>
                                                    <i className='fas fa-star'></i>
                                                    <i className='fas fa-star'></i>
                                                    <i className='fas fa-star'></i>
                                                    <i className='fas fa-star'></i>
                                                </span>
                                                <span>5.0</span>
                                            </div>
                                            <a href=''>www.bestatlaundry.com</a>
                                        </div>
                                    </div>
                                </div> */}
                <ul className="applinks">
                  <li>
                    <a target="_blank" href={appStorel}>
                      <img src={appstore} alt="" />
                    </a>
                  </li>

                  {/* <li>
                                    <a className='qrbox'><img src={qrcode} alt=""/></a>
                                </li> */}
                  <li>
                    <a target="_blank" href={playStore}>
                      <img src={googleplay} alt="" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mobapp-img text-center">
                <img
                  src={themeData?.theme_3?.home?.section_13?.banner}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileAppSection;
